/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Body_Measures_How_ChestInputs */

const en_us2_body_measures_how_chest = /** @type {(inputs: Body_Measures_How_ChestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`At nipple level, under the armpits and across the back at the same height. Arms loose, at the end of a normal breath out.`)
};

const pt_br2_body_measures_how_chest = /** @type {(inputs: Body_Measures_How_ChestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Na linha dos mamilos, passando sob as axilas e pelas costas na mesma altura. Braços soltos, ao fim de uma expiração normal.`)
};

const es_419_body_measures_how_chest = /** @type {(inputs: Body_Measures_How_ChestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A la altura de los pezones, pasando bajo las axilas y por la espalda a la misma altura. Brazos sueltos, al final de una exhalación normal.`)
};

const pt_pt2_body_measures_how_chest = /** @type {(inputs: Body_Measures_How_ChestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Na linha dos mamilos, a passar por baixo das axilas e pelas costas à mesma altura. Braços soltos, no fim de uma expiração normal.`)
};

const fr_fr2_body_measures_how_chest = /** @type {(inputs: Body_Measures_How_ChestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`À hauteur des mamelons, sous les aisselles et dans le dos à la même hauteur. Bras relâchés, à la fin d'une expiration normale.`)
};

const de_de2_body_measures_how_chest = /** @type {(inputs: Body_Measures_How_ChestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auf Höhe der Brustwarzen, unter den Achseln hindurch und am Rücken auf gleicher Höhe. Arme locker, am Ende einer normalen Ausatmung.`)
};

const it_it2_body_measures_how_chest = /** @type {(inputs: Body_Measures_How_ChestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All'altezza dei capezzoli, passando sotto le ascelle e sulla schiena alla stessa altezza. Braccia rilassate, alla fine di una normale espirazione.`)
};

/**
* | output |
* | --- |
* | "At nipple level, under the armpits and across the back at the same height. Arms loose, at the end of a normal breath out." |
*
* @param {Body_Measures_How_ChestInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_measures_how_chest = /** @type {((inputs?: Body_Measures_How_ChestInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Measures_How_ChestInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_measures_how_chest(inputs)
	if (locale === "es-419") return es_419_body_measures_how_chest(inputs)
	if (locale === "pt-PT") return pt_pt2_body_measures_how_chest(inputs)
	if (locale === "fr-FR") return fr_fr2_body_measures_how_chest(inputs)
	if (locale === "de-DE") return de_de2_body_measures_how_chest(inputs)
	if (locale === "it-IT") return it_it2_body_measures_how_chest(inputs)
	return en_us2_body_measures_how_chest(inputs)
});
export { body_measures_how_chest as "body-measures.how_chest" }